export default async function getZeroWaste({ context, nextMiddleware }){
    try {
        context.store.dispatch('menuUI/selectTab', 'zeroWaste');
    }
    catch(e){
        console.error(e);
        return context.next(false);
    }
    return nextMiddleware()
}
